import React, {PureComponent, type Node} from 'react';

import style from './cmsPopup.scss';

/**
 * Popup for terms and conditions popup
 */
export default class CmsPopup extends PureComponent {
    props: {
        cms: string,
    };

    /**
     * Render jsx to html
     * @returns {Node} Rendered react component
     */
    render(): Node {
        return (
            <div className={style.cmsPopup} dangerouslySetInnerHTML={{__html: this.props.cms}} />
        );
    }
}
